import { render } from "./messageRight.vue?vue&type=template&id=c1b6e468&scoped=true&ts=true"
import script from "./messageRight.vue?vue&type=script&lang=ts"
export * from "./messageRight.vue?vue&type=script&lang=ts"

import "./messageRight.vue?vue&type=style&index=0&id=c1b6e468&lang=less&scoped=true"

import exportComponent from "/Users/zhaoliang/Desktop/vue3-webim/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1b6e468"]])

export default __exports__